export default {"src":"/_next/static/media/icon-logo.c003e779.svg","height":17,"width":23,"blurWidth":0,"blurHeight":0};